<template>
  <div ref="container">

    <Fretboard :guitar="guitar"
               :showTones="showTones"
               :root="root"
               ref="horizFretboard"
               @fretClick="handleFretClick"
               v-if="isMobile === false"/>

    <FretboardVertical :guitar="guitar"
                       :showTones="showTones"
                       :root="root"
                       ref="vertFretboard"
                       @fretClick="handleFretClick"
                       v-if="isMobile===true"/>
  </div>

</template>


<script>

import Fretboard from "./Fretboard";
import FretboardVertical from "./FretboardVertical";


export default {
  components: {Fretboard, FretboardVertical},

  props: {
    'guitar': Object, 'root': Number, 'showTones': Boolean
  },

  data() {
    return {
      mobileBreakpoint: 600, isMobile: false, containerSize: null

    };
  },


  created() {

  },

  mounted() {

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },


  methods: {


    handleFretClick(params) {
      this.$emit('fretClick', params)
    },


    handleResize() {
      // Update the computed property when the window is resized
      this.isMobile = window.innerWidth < this.mobileBreakpoint;
      this.computeContainerSize()

    },


    beforeDestroy() {
      window.removeEventListener("resize", this.handleResize);
    },

    computeContainerSize() {

      if (this.$refs.container === undefined) {
        this.containerSize = {'w': -1, 'h': -1}
        return;
      }

      this.containerSize = {'height': this.$refs.container.clientHeight, 'width': this.$refs.container.clientWidth}
    }
  }
}

</script>

<style>

.appTitle {
  color: #222222;
}

.appPanel {
  background-color: #f2f2f3;

  padding: 1em;
  overflow: auto;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: content-box;
  box-sizing: border-box;
  height: 100%;
}

.fachords_app {
  background-color: #FFFFFF;
}

@media only screen and (max-width: 600px) {
  .fachords_app {
    height: 1100px;
  }

  .appControl {
    margin-bottom: 5px;
  }
}

@media only screen and (min-width: 600px) {
  .fachords_app {
    height: 400px;
  }
}

.hud {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.appSelectList {
  height: 35px; /* Adjust the height as needed */
  margin-right: 1px;
  padding-left: 5px;
  min-width: 150px;
  background-color: white;
  width: 40%;
}

.bpmControl {
  width: 70px;
  text-align: center;
  margin-left: 1px;
  margin-right: 1px;
}

.appInput {
  height: 35px;
  margin-left: 1px;
  margin-right: 1px;

}

.appButton {
  height: 35px; /* Adjust the height as needed */
  padding: 0 15px;
  color: #222;
  background-color: #fcfcfc;
  border: 1px solid #222222;

  cursor: pointer;
  margin-left: 1px;
  margin-right: 1px;
  width: 50px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
}

.appIcon {
  width: 24px; /* Adjust the width and height to fit your icon */
  height: 24px;
  fill: #fff; /* Fill color for the SVG icon */

}

.appButton:hover {
  background-color: #cecece
}


.fret {
  position: absolute;
  height: 35px;
  float: left;
  cursor: pointer;
  text-align: center;
  z-index: 5;

}


.fretIsPlaying {
  background-color: white !important;
}


/*color gradi 0-11*/
.color_degree_0 {
  background-color: #F7E721;
  color: #222222 !important;
}

.color_degree_1 {
  background-color: #C6DF31;
  color: #FFFFFF;
}

.color_degree_2 {
  background-color: #6BBE52;
  color: #FFFFFF;
}

.color_degree_3 {
  background-color: #00AE84;
  color: #FFFFFF;
}

.color_degree_4 {
  background-color: #00AECE;
  color: #FFFFFF;
}

.color_degree_5 {
  background-color: #0086CE;
  color: #FFFFFF;
}

.color_degree_6 {
  background-color: #4261AD;
  color: #FFFFFF;
}

.color_degree_7 {
  background-color: #8C499C;
  color: #FFFFFF;
}

.color_degree_8 {
  background-color: #E7288C;
  color: #FFFFFF;
}

.color_degree_9 {
  background-color: #EF4142;
  color: #FFFFFF;
}

.color_degree_10 {
  background-color: #F76929;
  color: #FFFFFF;
}

.color_degree_11 {
  background-color: #FFAE21;
  color: #FFFFFF;

}

.fretMarker {

  position: absolute;
  width: 15px !important;
  height: 15px !important;
  background-color: #a2a2a2;
  text-align: center;


  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;

  margin-top: -5px;

  z-index: 0;


}


.fretboardWood {
  background-image: url("/static/fachords3/tools/media/maple.jpg");
  background-repeat: repeat;

}

.note {
  color: #222222;
  background-color: #FEFEFE;
  padding: 4px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;

  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  pointer-events: none;


  font-size: 18px;

  overflow: hidden;
  white-space: nowrap;

  z-index: 5;

  height: 23px;
  width: 55px;
  min-width: 55px;

}

.noteLayer {


  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
  pointer-events: none;
  padding-top:1px!important;

  height: 28px !important;
  width: 26px !important;
  min-width: 26px !important;

  display: inline-block;

}

.isHovering {
  background-color: yellow;
}

.about_link {
  display: block;
  margin: 0;
  margin-bottom: -5px !important;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  color: #222;
  padding: 0px;
  font-weight: normal;
  transition: background-color 0.3s;
  line-height: 1.1;
}

.helpButton {
  position: relative;
  top: 0px;
  float: right;

}

.description {
  height: 80px;
  background-color: #fcfcfc;
  padding: 5px;
  text-align: center;
  line-height: 1.5em;
}
</style>
